"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.array.find");
var _shopList = require("@/api/shop/shopList");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'BasicInfo',
  props: {
    formData: {
      type: Object,
      required: false
    },
    regionOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    cityOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    supplierOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    areaOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      storeImages: [],
      qrCodeImages: [],
      offlineQrCodeImages: [],
      qrBgImages: [],
      welfareCodeImages: [],
      cardBackgroundImages: []
    };
  },
  created: function created() {
    this.initImages();
  },
  watch: {
    'formData.imgUrl': {
      handler: function handler(newVal) {
        this.syncFileList('storeImages', newVal, '新图1');
      },
      immediate: true
    },
    'formData.clientImgUrl': {
      handler: function handler(newVal) {
        this.syncFileList('qrCodeImages', newVal, '企业微信1');
      },
      immediate: true
    },
    'formData.offlineClientImgUrl': {
      handler: function handler(newVal) {
        this.syncFileList('offlineQrCodeImages', newVal, '线下企业二维码');
      },
      immediate: true
    },
    'formData.clientImgBgUrl': {
      handler: function handler(newVal) {
        this.syncFileList('qrBgImages', newVal, '二维码背景图');
      },
      immediate: true
    },
    'formData.welfareBackgroundImgUrl': {
      handler: function handler(newVal) {
        this.syncFileList('welfareCodeImages', newVal, '福利社背景图');
      },
      immediate: true
    },
    'formData.cardBackgroundImgUrl': {
      handler: function handler(newVal) {
        this.syncFileList('cardBackgroundImages', newVal, '门店卡片背景图');
      },
      immediate: true
    }
  },
  computed: {
    getCityOptions: function getCityOptions() {
      var _this = this;
      var province = this.regionOptions.find(function (p) {
        return p.regionId === _this.formData.provinceId;
      });
      (0, _shopList.getRegionList)(province).then(function (res) {
        _this.cityOptions = res.data;
      });
    }
  },
  methods: {
    /**
     * 同步图片列表：将 dbPath 转为 el-upload fileList 格式
     * 数据库路径已包含 /images/mall，直接拼 VUE_APP_COMMENT_IMAGE_URL
     */
    syncFileList: function syncFileList(listKey, dbPath, defaultName) {
      if (dbPath && dbPath !== '') {
        var fullPath = dbPath;
        // 上传接口返回的路径没有 /images/mall 前缀，需要补上
        if (!fullPath.startsWith('http') && !fullPath.startsWith('/images/mall') && !fullPath.startsWith('/images')) {
          fullPath = '/images/mall' + fullPath;
        }
        var url = fullPath.startsWith('http') ? fullPath : process.env.VUE_APP_COMMENT_IMAGE_URL + fullPath;
        this[listKey] = [{
          name: defaultName,
          url: url
        }];
      } else {
        this[listKey] = [];
      }
    },
    initImages: function initImages() {
      this.syncFileList('storeImages', this.formData.imgUrl, '新图1');
      this.syncFileList('qrCodeImages', this.formData.clientImgUrl, '企业微信1');
      this.syncFileList('offlineQrCodeImages', this.formData.offlineClientImgUrl, '线下企业二维码');
      this.syncFileList('qrBgImages', this.formData.clientImgBgUrl, '二维码背景图');
      this.syncFileList('welfareCodeImages', this.formData.welfareBackgroundImgUrl, '福利社背景图');
      this.syncFileList('cardBackgroundImages', this.formData.cardBackgroundImgUrl, '门店卡片背景图');
    },
    handleProvinceChange: function handleProvinceChange() {
      this.formData.cityId = '';
      this.getCityOptions();
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.$emit('preview-image', file);
    },
    handleExceed: function handleExceed() {
      this.$message.warning('只能上传一张图片，新图片将替换原有图片');
    },
    beforeImageUpload: function beforeImageUpload(file) {
      var isImage = file.type.startsWith('image/');
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2MB！');
        return false;
      }
      return true;
    },
    /**
     * 通用图片上传方法：先上传文件拿到相对路径，再更新 formData
     * @param {File} raw - 原始文件对象
     * @param {string} field - formData 中对应的字段名
     * @param {string} listKey - 预览列表的 data key
     * @param {string} defaultName - 预览文件名
     * @param {string} uploadPath - 上传路径
     */
    doUpload: function doUpload(raw, field, listKey, defaultName, uploadPath) {
      var _this2 = this;
      // 先展示本地预览
      this[listKey] = [{
        name: defaultName,
        url: URL.createObjectURL(raw)
      }];
      (0, _shopList.uploadImage)(raw, uploadPath).then(function (res) {
        var relativePath = res.data;
        // 复用 syncFileList 更新预览
        _this2.syncFileList(listKey, relativePath, defaultName);
        _this2.$emit('update:formData', _objectSpread(_objectSpread({}, _this2.formData), {}, (0, _defineProperty2.default)({}, field, relativePath)));
      }).catch(function () {
        // 上传失败恢复原状
        _this2.syncFileList(listKey, _this2.formData[field], defaultName);
        _this2.$message.error('图片上传失败');
      });
    },
    // ---- 各图片字段的 change / remove ----
    handleRemove: function handleRemove(file, fileList) {
      this.storeImages = fileList;
      this.$emit('update:formData', _objectSpread(_objectSpread({}, this.formData), {}, {
        imgUrl: ''
      }));
    },
    handleImageChange: function handleImageChange(file) {
      this.doUpload(file.raw, 'imgUrl', 'storeImages', '新图1', '/storeImg/');
    },
    handleQrRemove: function handleQrRemove(file, fileList) {
      this.qrCodeImages = fileList;
      this.$emit('update:formData', _objectSpread(_objectSpread({}, this.formData), {}, {
        clientImgUrl: ''
      }));
    },
    handleQrChange: function handleQrChange(file) {
      this.doUpload(file.raw, 'clientImgUrl', 'qrCodeImages', '企业微信1', '/wxapp/');
    },
    handleOfflineQrRemove: function handleOfflineQrRemove(file, fileList) {
      this.offlineQrCodeImages = fileList;
      this.$emit('update:formData', _objectSpread(_objectSpread({}, this.formData), {}, {
        offlineClientImgUrl: ''
      }));
    },
    handleOfflineQrChange: function handleOfflineQrChange(file) {
      this.doUpload(file.raw, 'offlineClientImgUrl', 'offlineQrCodeImages', '线下企业二维码', '/wxapp/');
    },
    handleQrBgRemove: function handleQrBgRemove(file, fileList) {
      this.qrBgImages = fileList;
      this.$emit('update:formData', _objectSpread(_objectSpread({}, this.formData), {}, {
        clientImgBgUrl: ''
      }));
    },
    handleQrBgChange: function handleQrBgChange(file) {
      this.doUpload(file.raw, 'clientImgBgUrl', 'qrBgImages', '二维码背景图', '/wxBgApp/');
    },
    handleWelfareRemove: function handleWelfareRemove(file, fileList) {
      this.welfareCodeImages = fileList;
      this.$emit('update:formData', _objectSpread(_objectSpread({}, this.formData), {}, {
        welfareBackgroundImgUrl: ''
      }));
    },
    handleWelfareChange: function handleWelfareChange(file) {
      this.doUpload(file.raw, 'welfareBackgroundImgUrl', 'welfareCodeImages', '福利社背景图', '/welfareBackgroundImage/');
    },
    handleCardBackgroundRemove: function handleCardBackgroundRemove(file, fileList) {
      this.cardBackgroundImages = fileList;
      this.$emit('update:formData', _objectSpread(_objectSpread({}, this.formData), {}, {
        cardBackgroundImgUrl: ''
      }));
    },
    handleCardBackgroundChange: function handleCardBackgroundChange(file) {
      this.doUpload(file.raw, 'cardBackgroundImgUrl', 'cardBackgroundImages', '门店卡片背景图', '/cardBackgroundImg/');
    }
  }
};